import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Features from './pages/Features';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import Documentation from './pages/Documentation';
import Signup from './pages/Signup';
import MiniApp from './miniapp/App';
import DriverMiniApp from './miniapp_driver/App';

function App() {
  const location = useLocation();
  const isMiniAppRoute = location.pathname.startsWith('/miniapp') || location.pathname.startsWith('/miniapp-driver');

  return (
    <div className="App">
      <Helmet>
        <title>Boulevard - Smart Ride Matching Platform</title>
        <meta name="description" content="Connect drivers and riders seamlessly through our intelligent Telegram bot system." />
      </Helmet>

      {!isMiniAppRoute && <Navbar />}

      <main className={isMiniAppRoute ? 'miniapp-container' : undefined}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/features" element={<Features />} />
          <Route path="/docs" element={<Documentation />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/miniapp" element={<MiniApp />} />
          <Route path="/miniapp-driver" element={<DriverMiniApp />} />
        </Routes>
      </main>

      {!isMiniAppRoute && <Footer />}
    </div>
  );
}

export default App;
